import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { routes } from './routes';
import { SharedModule } from '../shared/shared.module';
import { RouterModule, Router } from '@angular/router';
import { MenuServiceService } from '../services/menu/menu-service.service';
import { MainService } from '../services/main/main.service';
import { PublicModule } from './public/public.module';
import { AuthService } from '../services/auth/auth.service';
import { MiscModule } from './misc/misc.module';
import { DownloadComponent } from './download/download.component';
import { TrainingExportComponent } from './training-export/training-export.component';
import { UpgradePlanComponent } from './upgrade-plan/upgrade-plan.component';
import { ComparePlansComponent } from './compare-plans/compare-plans.component';
import { isNgTemplate } from '@angular/compiler';
import { InstantPayoutComponent } from './instant-payout/instant-payout.component';
import { MatDialogRef } from '@angular/material/dialog';
import { getUserProfiles } from 'src/app/core/session';
@NgModule({
  declarations: [
    DownloadComponent,
    TrainingExportComponent,
    InstantPayoutComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'}),
    PublicModule,
    MiscModule,
    SharedModule
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {}
    },
 ],
  exports: [RouterModule],
})
export class PagesModule {
  constructor(public menu: MenuServiceService, public mainService: MainService, public auth:AuthService, public router:Router){
    menu.resetMenu();
    const subs = this.mainService.available_menu.subscribe(server_menu => {
      if (server_menu) {
        if (typeof server_menu === 'object' && server_menu.length > 0) {
          let userProfileData = getUserProfiles();
          if (userProfileData && userProfileData[0] && userProfileData[0].role_id == 4) {
            if (userProfileData[0].show_financial_settings != 1) {
              server_menu = server_menu.filter(menu => menu.link != '/app/global-settings');
              server_menu = server_menu.map(menu => {
                if (menu.submenu && menu.submenu.length > 0) {
                  return {
                    ...menu,
                    submenu: menu.submenu.filter((sub: any) => sub.link != '/app/global-settings')
                  };
                }
                return menu;
              });
            }
            if (userProfileData[0].business_verification_state != 'other_info_updated') {
              server_menu = server_menu.filter(menu => !menu.link.includes('/app/process-payment'));
            }
            if (userProfileData[0].show_ar != 1) {
              server_menu = server_menu.filter(menu => !menu.link.includes('/app/accounts-receivable'));
            }
          }
          menu.resetMenu();
          this.mainService.routerAuth.main_menu = [...server_menu];
          this.mainService.routerAuth.routeAuth([...server_menu]);
          const main_menu = JSON.parse(JSON.stringify(server_menu));
          let all_menu = [];
          main_menu && main_menu.forEach((item, index) => {
            let submenu = null;
            if (item['submenu'] && item['submenu'].length > 0) {
              item['submenu'] && item['submenu'].forEach((sub, i) => {
                if (sub['only_path'] !== '1') {
                  if(!submenu) {
                    submenu = [];
                  }
                  submenu.push(sub);
                }
              });
            }
            item.submenu = submenu;
            if (item['only_path'] !== '1') {
              all_menu.push(item);
            }
          });
          all_menu && all_menu.forEach((item: any) => {
            if (item.submenu) {
              item.submenu = item.submenu.sort((a: any, b: any) => {
                return a.in_order - b.in_order;
              });
              if (item.submenu.length === 0) {
                item.submenu = null;
              }
            }
          });
          menu.addMenu(all_menu);
        }
      }
    });
  }
 }
